<div class="grid gap-4 p-4 text-sm">
  <div>
    <div>Province: {{ $ridJourneyService.chosenProvince()?.name ?? ($ridJourneyService.isChoosingProvince() ? 'choosing' : 'none') }}</div>
    <div>Location: {{ $ridJourneyService.chosenLocation()?.name ?? 'none' }}</div>
    <div>New stop today: {{ $ridHomeworkService.canStartNewStop() ? 'yes' : 'no' }}</div>
  </div>

  @for (stop of $lpApiService.state().homework.stops; track stop.id) {
    @let link = linkFor(stop.id);
    <div class="rounded-md border border-gray-300 p-2">
      <div class="font-bold">
        Stop {{ $index + 1 }} ({{ stop.id }}) -
        @if (link) {
          linked to {{ link.locationStopUid }} on {{ link.linkedDate }}
        } @else {
          not linked
        }
      </div>
      <ul class="ml-4 list-disc">
        @for (assignment of stop.assignments; track assignment.config.uid) {
          @let activityUid = activityUidFor(stop.id, assignment.config.uid);
          <li>
            {{ assignment.config.dataType }} -
            @if (isFinished(activityUid)) {
              <span class="text-green-600">finished</span>
            } @else if (activityUid) {
              <span class="text-yellow-600">started ({{ activityUid }})</span>
            } @else {
              <span class="text-gray-500">not started</span>
            }
          </li>
        }
      </ul>
    </div>
  }
</div>
